export const CALENDAR_GRID_DAY_POPOVER_ORDER_FALLBACK = 0

export const QA_NAME_CALENDAR_GRID_DAY_POPOVER = 'calendarGridDayPopover'

export const QA_NAME_CALENDAR_GRID_DAY_POPOVER_EMPTY =
  'calendarGridDayPopoverEmpty'

export const QA_NAME_CALENDAR_GRID_DAY_POPOVER_LOAD =
  'calendarGridDayPopoverLoad'

export const QA_NAME_CALENDAR_GRID_DAY_POPOVER_SUMMARY =
  'calendarGridDayPopoverSummary'
